import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const portalRoot = document.getElementById('portal');

const Portal = ({ isPortal = true, children }) => {
	const ref = useRef(isPortal ? document.createElement('div') : null);

	/* eslint-disable */
	useEffect(() => {
		if (!isPortal) return;
		portalRoot.appendChild(ref.current);
		return () => portalRoot.removeChild(ref.current);
	}, []);
	/* eslint-enable */

	return isPortal ? ReactDOM.createPortal(children, ref.current) : children;
};

export default Portal;
